"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const immer_1 = require("immer");
const reducer_1 = __importDefault(require("./authentication/reducer"));
const reducer_2 = __importDefault(require("./account/reducer"));
const reducer_3 = __importDefault(require("./project/reducer"));
const reducer_4 = __importDefault(require("./tools/reducer"));
const reducer_5 = __importDefault(require("./transformModes/reducer"));
const reducer_6 = __importDefault(require("./widgets/behavior/reducer"));
const widgetReducers = __importStar(require("./widgets/content/reducers"));
const reducer_7 = __importDefault(require("./contextmenu/reducer"));
const reducer_8 = __importDefault(require("./catalogMeta/reducer"));
const reducer_9 = __importDefault(require("./catalog/reducer"));
const reducer_10 = __importDefault(require("./quote/reducer"));
const reducer_11 = __importDefault(require("./data/reducer"));
const reducer_12 = __importDefault(require("./selectedObjects/reducer"));
const reducer_13 = __importDefault(require("./unitOfMeasurement/reducer"));
const reducer_14 = __importDefault(require("./user/reducer"));
const reducer_15 = __importDefault(require("./customerManagement/reducer"));
(0, immer_1.enableMapSet)();
exports.default = () => (0, redux_1.combineReducers)(Object.assign(Object.assign({ project: reducer_3.default,
    tools: reducer_4.default,
    transformModes: reducer_5.default,
    widgets: reducer_6.default,
    contextmenu: reducer_7.default,
    catalogMeta: reducer_8.default,
    catalog: reducer_9.default }, widgetReducers), { quote: reducer_10.default,
    data: reducer_11.default,
    selectedObjects: reducer_12.default,
    unitOfMeasurement: reducer_13.default,
    authenticate: reducer_1.default,
    user: reducer_14.default,
    account: reducer_2.default,
    customerManagement: reducer_15.default }));
